import React, { useState} from "react";
import {notifyError, notifySuccess, } from "../../utils/helpers";
import {
    BUTTON,
    MODAL_CANCEL_TEXT,
    SAVING_TEXT, D2L_MODULE_NAME_TEXT, MODAL_CLOSE_TEXT, CREATE_MODULE, INTEGRATION_TYPES, CREATE_SECTION
} from "../../utils/constants";
import {Modal} from "react-bootstrap";
import YuJaButton from "../standardization/YuJaButton";
import { ReactComponent as ModalClose } from "../../images/modal_close.svg";

import {YuJaTextBox} from "../standardization/YuJaTextBox";
import {SAVE_D2L_MODULE_SUCCESS} from "../../utils/toast-message-constants";
import classes from "../../pages/CreateQuizPage/ActivityEditor.module.css";
import {LTIApiCalls} from "../../apis/LTIApiCalls";
import {useSynLMSConfiguration} from "../../hooks/useSynLMSConfiguration";


export default function CreateD2LModuleModal({setModalShow, show, selectedCourseId, saveSuccessCb}) {
    const {createD2LModule, createMoodleSection} = LTIApiCalls();
    const {getIntegrationType} = useSynLMSConfiguration();

    const [newName, setNewName] = useState("");
    const [isSaving, setIsSaving] = useState(false);

    let integrationType = getIntegrationType();

    const handleClose = () =>{
        resetStatus();
        setModalShow(false);
    };

    const resetStatus = () => {
        setNewName("");
    }


    const handleSave = () => {
        if (!newName) {
            notifyError(integrationType === INTEGRATION_TYPES.D2L
                ? "Module name can not be empty."
                : "Section name can not be empty."
            );
            return;
        }

        setIsSaving(true);
        if (integrationType === INTEGRATION_TYPES.D2L) {
            createD2LModule(selectedCourseId, newName).then((success) => {
                if (success) {
                    notifySuccess(SAVE_D2L_MODULE_SUCCESS.replace(D2L_MODULE_NAME_TEXT, newName));
                    saveSuccessCb();
                }

                setModalShow(false);

            }).finally(() => setIsSaving(false));
        } else {
            createMoodleSection(selectedCourseId, newName).then((success) => {
                if (success) {
                    notifySuccess(SAVE_D2L_MODULE_SUCCESS.replace(D2L_MODULE_NAME_TEXT, newName));
                    saveSuccessCb();
                }

                setModalShow(false);

            }).finally(() => setIsSaving(false));
        }


    }

    return (
        <Modal
            id="form-modal"
            show={show}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={true}
            dialogClassName= {"save-question-bank-modal"}
        >

            <ModalClose
                tabIndex={0}
                role={BUTTON}
                aria-label={MODAL_CLOSE_TEXT}
                onClick={handleClose}
                className="modal-close"
                style={{width: "24px", height: "24px"}}
            />
            <Modal.Header
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <Modal.Title className="modal-title" >
                    {"Create"}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{display: "flex", flexDirection: "column", gap: 25, minHeight: 100}}>
                <span style={{color: "#6B6B6B", fontSize: 15, fontWeight: "400"}}>
                    {integrationType === INTEGRATION_TYPES.D2L
                        ? "Give the module a name to create it inside the selected course."
                        : "Give the section a name to create it inside the selected course."
                    }
                </span>
                <YuJaTextBox
                    value={newName}
                    containerStyle={{width: 250, height: 40, fontSize: 15}}
                    onChange={e => setNewName(e.target.value)}
                    placeholder={integrationType === INTEGRATION_TYPES.D2L  ? "Enter module name" : "Enter section name"}
                />
            </Modal.Body>
            <Modal.Footer>
                <div style={{display: "flex", width: "100%", alignItems: "center", justifyContent: "flex-end", gap: 10}}>
                    <span style={{display: "flex", width: "100%", alignItems: "center", justifyContent: "flex-end", gap: 10}}>
                        <YuJaButton
                            onClick={handleClose}
                            type={"secondary"}
                            style={{width: 120, height: 35, display: "flex", alignItems: "center", justifyContent: "center"}}
                        >
                           {MODAL_CANCEL_TEXT}
                        </YuJaButton>

                        <YuJaButton
                            onClick={handleSave}
                            disabled={!newName}
                            style={{width: 120, height: 35, display: "flex", alignItems: "center", justifyContent: "center", whiteSpace: "nowrap"}}
                        >
                           {isSaving
                               ? <span className={classes.savingText}>{SAVING_TEXT}</span>
                               : (integrationType === INTEGRATION_TYPES.D2L ? CREATE_MODULE : CREATE_SECTION)
                           }
                        </YuJaButton>
                    </span>
                </div>
            </Modal.Footer>

        </Modal>
    );
}